import { useAuthStore } from '@/store/auth';
import { getQueryClient } from './queryClient';

let hasHandledExpiration = false;

export function handleSessionExpired(): void {
    if (hasHandledExpiration) {
        return;
    }

    hasHandledExpiration = true;

    const { logout, setIsLoggingOut } = useAuthStore.getState();
    setIsLoggingOut(true);

    const queryClient = getQueryClient();
    queryClient.clear();

    logout();

    if (window.location.pathname !== '/login') {
        window.location.replace('/login');
    }
}
